import { render, staticRenderFns } from "./textTitle-temp3.vue?vue&type=template&id=fca14092&scoped=true"
import script from "./textTitle-temp3.vue?vue&type=script&lang=js"
export * from "./textTitle-temp3.vue?vue&type=script&lang=js"
import style0 from "./textTitle-temp3.vue?vue&type=style&index=0&id=fca14092&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca14092",
  null
  
)

export default component.exports